import {Component, Mixins} from 'vue-property-decorator';
import ProductPriorityDataMixin from '@/components/product/ProductPriorityDataMixin';
import {writeExcel, getStorageByName} from '@/utils/excel';
import {getDownToday, changeDateFormat} from '@/utils/dateUtils';
import XLSX from 'xlsx';
import {centerWinOptions} from '@/utils/commonUtils';
import TuiGrid from 'tui-grid';
import Cookies from 'js-cookie';
import {Mall} from 'supporter';
import {State} from 'vuex-class';
const set = require('lodash.set');

interface CommonObject {
  [propName: string]: any;
}

//receive from productPopSearch (mallProducts of checked)
let remove: Function;
let addProductsFromPop: Function;
window.addEventListener(
  'message',
  function(event: any): void {
    if (typeof event === 'object' && event.data) {
      if (event.data.productPopSearchMallProductsNosForRemove) {
        remove(event.data.data);
      }

      if (event.data.productPopSearchMallProductsNosForAdd) {
        addProductsFromPop(event.data.data);
      }
    }
  },
  false
);

@Component
export default class ProductPriorityMethodsMixin extends Mixins(ProductPriorityDataMixin) {
  @State('malls', {namespace: 'mall'})
  public malls!: Mall[];

  public search(mallNo?: number): void {
    // if (this.isModified) {
    //   if (!confirm(this.toI18n('PRODUCT_PRIORITY_IS_MODIFIED'))) {
    //     return;
    //   }
    // }
    this.isInvalidOfKeyword = false;

    if (mallNo) this.currentMallNo = mallNo;
    this.isModified = false;
    const params = {
      mallNo: this.currentMallNo
    };
    this.$api.getDisplayPriorities({params}).then(({data}): void => {
      this.searchRespones = data;
      this.dataLength = (data as []).length;
      this.setLocalStorage(data as []);
    });
  }

  public setLocalStorage(data: []): void {
    localStorage.setItem('productPriorityProductNos', JSON.stringify((data as []).map((item: any): any => item.productNo)));
  }

  public getTuiGrid(): any {
    return (this.$refs.priorityGrid as any).$refs.tuiGrid;
  }

  public handleArrayData(data: any): any {
    const {
      productNo,
      productManagementCd,
      productName,
      brandName,
      partnerName,
      applyStatusType,
      saleStatusType,
      saleSettingStatusType,
      displayable,
      priceAppliedImmediateDiscount,
      stock,
      onlyAccessUrl,
    } = data;
    return {
      productNo,
      productManagementCd,
      productName,
      brandName,
      partnerName,
      applyStatusType,
      saleStatusType,
      saleSettingStatusType,
      displayable,
      priceAppliedImmediateDiscount,
      stock,
      onlyAccessUrl,
    };
  }

  public gridResetData(filterFn?: Function): void {
    const grid = this.getTuiGrid();
    let data = [];

    if (filterFn) {
      data = grid
        .invoke('getData')
        .map((item: any): void => this.handleArrayData(item))
        .filter(filterFn);
    } else {
      data = grid.invoke('getData').map((item: any): void => this.handleArrayData(item));
    }

    grid.invoke('resetData', data);
    this.dataLength = data.length;
    this.isModified = true;
    this.setLocalStorage(data as []);
  }

  public girdItemPositionSwitch(): void {
    $('.content_item_bx').on('mousedown', '.controlBtn.actionBtn', ({currentTarget}: Event): void => {
      const $this = $(currentTarget);
      if ($this.hasClass('disabled')) return;
      const upOrDown = $this.data('type');
      const rowKey = $this.data('rowkey');

      const grid = this.getTuiGrid();
      const rawData = grid.invoke('getData');

      if (upOrDown === 'up') {
        const x = {...rawData[rowKey - 1]};
        const y = {...rawData[rowKey]};
        grid.invoke('setRow', rowKey - 1, y);
        grid.invoke('setRow', rowKey, x);
      } else {
        const x = {...rawData[rowKey]};
        const y = {...rawData[rowKey + 1]};
        grid.invoke('setRow', rowKey, y);
        grid.invoke('setRow', rowKey + 1, x);
      }

      this.gridResetData();
    });
  }

  public deleteChecked(): void {
    const grid = this.getTuiGrid();
    const checkedRows = grid.invoke('getCheckedRows');

    if (!checkedRows.length) {
      alert(this.toI18n('PRODUCT_PRIORITY_GRID_LENGTH_ALERT'));
      return;
    }
    if (confirm(this.toI18n('PRODUCT_PRIORITY_GRID_MANY_ROWS_ALERT'))) {
      grid.invoke('removeCheckedRows');
      this.gridResetData();
    }
  }

  public moveItemTo(pos: string): void {
    const grid = this.getTuiGrid();
    const checkedRows = grid.invoke('getCheckedRows');

    if (!checkedRows.length) {
      alert(this.toI18n('PRODUCT_PRIORITY_PLEASE_SELECT_ALERT'));
      return;
    }

    const prepareDeleteData = checkedRows.map((item: any): void => this.handleArrayData(item));
    const productNos = prepareDeleteData.map((item: any): void => item.productNo);
    grid.invoke('removeCheckedRows');

    if (pos === 'top') {
      prepareDeleteData.reverse().forEach((item: any): void => {
        grid.invoke('prependRow', item);
      });
    } else {
      grid.invoke('appendRows', prepareDeleteData);
    }

    this.gridResetData();

    const items = grid.invoke('getData').filter((item: any): void => productNos.includes(item.productNo));
    const rowKeys = items.map((item: any): number => item.rowKey);

    rowKeys.forEach((rowKey: any): void => {
      grid.invoke('check', rowKey);
    });

    setTimeout(function(): void {
      const gridBody = document.querySelector('.tui-grid-body-area');
      if (pos === 'top') {
        gridBody.scrollTop = 0;
      } else {
        gridBody.scrollTop = 840;
      }
    });
  }

  public removeProductRowEvent(): void {
    $('.content_item_bx').on('click', '.removeBtn', ({currentTarget}: Event): void => {
      const $this = $(currentTarget);
      const productNo = $this.data('productNo');
      const grid = this.getTuiGrid();
      const rowKey = $this.closest('td').data('rowKey');

      if (confirm(`${this.toI18n('PRODUCT_PRIORITY_CONFIRM1')}(${productNo})${this.toI18n('PRODUCT_PRIORITY_COMFIRM2')}`)) {
        this.gridResetData((item: any): boolean => item.productNo !== productNo);

        const nowData = grid.invoke('getData');
        setTimeout(function(): void {
          if (rowKey <= nowData.length - 1) {
            grid.invoke('focusAt', rowKey, 10, true);
          } else {
            grid.invoke('focusAt', rowKey - 1, 10, true);
          }
        });
      }
    });
  }

  public downDataExcel(): void {
    const params = {
      mallNo: this.currentMallNo
    };
    this.$api.getDisplayPrioritiesExcel({params}).then(({data}: any): void => {
      if (data.length === 0) {
        alert(this.$t('COMMON_NOT_DATA'));
        return;
      }
      const excelColumn: any = {};
      this.excelColumns.forEach((column: any): void => {
        excelColumn[column.name] = column.header;
      });

      const filename = 'Upload_ProductDisplayPriority_productNo_' + getDownToday();
      writeExcel(data, excelColumn, filename, this.excelFormatter);
    });
  }

  public downExcelTemplate(): void {
    // window.location.assign(this.searchTypeExcelDownURL);
    getStorageByName(this.searchTypeExcelDownURL);
  }

  public triggerOpenFileDailog(): void {
    $('#excelFile')
      .val('')
      .trigger('click');
  }

  public makeExcelName(text: string): string {
    const timePostFix = changeDateFormat(new Date(), 'yyyyMMdd_HHmmss');
    return `${text}_${timePostFix}`;
  }

  public sortingProductList(mallProducts: CommonObject[]): CommonObject[] {
    return mallProducts.sort((a, b): any => (a.priority < b.priority ? -1 : a.priority > b.priority ? 1 : 0));
  }

  public callbackAfterToJson(fileId: any, keyMapJson: any, callback: any): void {
    function _arrayBufferToStr(data: ArrayBuffer): any {
      let o = '',
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w, l * w + w)) as any);
      o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w)) as any);

      return o;
    }

    function _processWorkbook(workbook: any, keyMapJson: any, callback: any): any {
      let firstSheetName = workbook.SheetNames[0];
      let rowObjectArray = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName]);
      let json = JSON.stringify(rowObjectArray);
      json = json.replace(/"\s+|\s+"/gi, '"');
      $.each(keyMapJson, function(key, value): any {
        json = json.replace(new RegExp('"' + (key as string) + '"', 'g'), '"' + value + '"');
      });

      callback(JSON.parse(json));
    }

    if (typeof FileReader === 'undefined') {
      let ExcelError = function(): void {
        this.name = 'FileReader Not Found Exception';
        this.message = this.toI18n('PRODUCT_PRIORITY_MESSAGE1');
      };
      ExcelError.prototype = new Error();
      return new ExcelError();
    }

    let fileObj = typeof fileId === 'object' ? fileId : $(`#${fileId}`);
    if (fileObj == null || fileObj.length == 0) {
      // eslint-disable-next-line quotes
      throw new Error(this.toI18n('PRODUCT_PRIORITY_ERROR1'));
    }

    if (fileObj[0].files.length == 0) {
      throw new Error(this.toI18n('PRODUCT_PRIORITY_ERROR2'));
    }

    let file = fileObj[0].files[0];

    let isUsableReadAsBinaryString = typeof FileReader.prototype.readAsBinaryString !== 'undefined';
    // let isUsableWorker = typeof Worker !== 'undefined';

    let reader = new FileReader();

    reader.onload = function(e: any): void {
      let data = e.target.result;
      let workbook;
      if (isUsableReadAsBinaryString) {
        workbook = XLSX.read(data, {type: 'binary'});
      } else {
        let str = _arrayBufferToStr(data);
        workbook = XLSX.read(btoa(str), {type: 'base64'});
      }
      _processWorkbook(workbook, keyMapJson, callback);
    };

    if (isUsableReadAsBinaryString) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }

  public convertData(searchType: string, excelData: CommonObject[]): void {
    const searchNo = searchType === 'mallProductNo';
    const keyMapJson: CommonObject = {};
    keyMapJson[searchType] = searchNo ? this.toI18n('PRODUCT_PRIORITY_PRODUCT_NUMBER') : this.toI18n('PRODUCT_PRIORITY_PRODUCT_MANAGEMENT_CODE');
    keyMapJson.result = this.toI18n('PRODUCT_PRIORITY_REGISTRATION_RESULT');
    keyMapJson.priority = this.toI18n('PRODUCT_PRIORITY_ORDER');

    const typeData = excelData.filter((v): boolean => !!v[searchType]).map((v): void => v[searchType]);
    const keyword = typeData.join(',');

    if (!excelData.length || !typeData.length) {
      alert(this.toI18n('PRODUCT_PRIORITY_PLEASE_CHECK_THE_EXCEL_FORM_AGAIN'));
      return;
    }

    this.addProductBySearch(searchType, keyword, keyword.split(','), (mallProducts: any): void => {
      const successList = mallProducts.map((mallProduct: any): string => mallProduct[searchType]);
      const beforeList = [];
      excelData.forEach((v: any): void => {
        const value = searchNo ? parseInt(v[searchType], 10) : v[searchType];
        v.result = this.toI18n('PRODUCT_PRIORITY_FAILURE');

        if (successList.includes(value) && !beforeList.includes(value)) {
          beforeList.push(value);
          v.result = this.toI18n('PRODUCT_PRIORITY_SUCCESS');
        }
      });

      writeExcel(excelData, keyMapJson, this.makeExcelName(`Upload_ProductDisplayPriority_${searchNo ? 'ProductNo' : 'ProductManagementCode'}`), {});
    });
  }

  public excelUpload(e: any): void {
    const file = e.target.files[0];
    if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
      alert(this.toI18n('PRODUCT_PRIORITY_REGISTRATION_FAILED_MSG'));

      return;
    }

    const searchType = this.searchTypeForExcel === 'mallProductNo' ? 'mallProductNo' : 'productManagementCd';
    const keyMapJson =
      searchType === 'mallProductNo' ? {[this.toI18n('PRODUCT_PRIORITY_PRODUCT_NUMBER')]: 'mallProductNo'} : {[this.toI18n('PRODUCT_PRIORITY_PRODUCT_MANAGEMENT_CODE')]: 'productManagementCd'};
    this.callbackAfterToJson('excelFile', keyMapJson, $.proxy(this.convertData, this, searchType));
  }

  public getGridProductNos(): number[] {
    const grid = this.getTuiGrid();
    return grid.invoke('getColumnValues', 'productNo');
  }

  public keywordCheck(): boolean {
    const value = this.keyword.replace(/(?:\\[rn]|[\r\n]+)+/g, ',');
    const regex = /^[0-9,]+$/;

    if (!regex.test(value)) {
      this.invalid(this.toI18n('PRODUCT_PRIORITY_YOU_CAN_ONLY_ENTER_NUMBERS_AND_COMMAS'));

      return false;
    }

    if (value.split(',').filter((v: any): boolean => v.length > 10).length) {
      this.invalid(this.toI18n('PRODUCT_PRIORITY_THE_PRODUCT_NUMBER_CAN_BE_UP_TO_10_CHARACTERS_LONG'));

      return false;
    }

    this.isInvalidOfKeyword = false;
    return true;
  }

  public invalid(msg: string): void {
    this.invalidMsg = msg;
    this.isInvalidOfKeyword = true;
  }

  public addProductSuccessHandle(mallProducts: any): void {
    const grid = this.getTuiGrid();
    const successMallProductNos = mallProducts.map((v: any): any => {
      return v.mallProductNo ? v.mallProductNo : v.productNo;
    });
    grid.invoke('getData').forEach((row: any): void => {
      if (successMallProductNos.includes(row.productNo)) {
        grid.invoke('check', row.rowKey);
        // TODO
        // grid.invoke('addRowClassName', row.rowKey, 'product-item-checked');
      }
    });
  }

  public addProductBySearch(searchType: string, keyword: string, keywordList: any, callBack?: Function): void {
    let searchTypeParam = 'MALL_PRODUCT_NO';
    switch (searchType) {
      case 'productManagementCd':
        searchTypeParam = 'PRODUCT_MANAGEMENT_CD';
        break;
      case 'productManagementCdLike':
        searchTypeParam = 'PRODUCT_MANAGEMENT_CD_LIKE';
        break;
    }

    const params = {
      mallNos: [Number(this.currentMallNo)],
      'keywordInfo.type': searchTypeParam,
      'keywordInfo.keywords': keyword,
      'periodInfo.type': 'REGISTER_DATE',
      'periodInfo.period.startYmdt': '1970-01-01 00:00:00',
      'periodInfo.period.endYmdt': '2999-12-31 23:59:59',
      exceptedMallProductNos: JSON.parse(localStorage.productPriorityProductNos),
      page: 1,
      size: keywordList.length
    };

    const newParams = {};
    Object.keys(params).forEach((v: any): void => {
      set(newParams, v, params[v]);
    });
    if (newParams['keywordInfo']['keywords']) {
      Object.assign(newParams['keywordInfo'], {
        keywords: newParams['keywordInfo']['keywords'].split(',')
      });
    } else {
      delete newParams['keywordInfo']['keywords'];
    }

    this.$api.postProductsSearch({data: newParams} as any).then(({data}): void => {
      const {contents: mallProducts} = data;
      let allAdded = searchType === 'mallProductNo' ? mallProducts.length === keywordList.length : !!mallProducts.length;

      let savedCount = 0;
      let savedValue = [];
      const grid = this.getTuiGrid();
      const listData = grid.invoke('getData').map((item: any): void => this.handleArrayData(item));
      (listData as []).forEach((item: any): any => {
        keywordList.forEach((key: any): any => {
          if (item.productNo == key.toString()) {
            allAdded = false;
            savedCount++;
            savedValue.push(key);
          }
        });
      });

      if (allAdded) {
        alert(`${mallProducts.length}${this.toI18n('PRODUCT_PRIORITY_PRODUCTS_HAVE_BEEN_REGISTERED')}`);
      } else if (!mallProducts.length || mallProducts.length == savedCount) {
        alert(this.toI18n('PRODUCT_PRIORITY_THERE_ARE_NO_PRODUCTS_AVAILABLE_FOR_REGISTRATION'));
        return;
      } else {
        let searchList = mallProducts.map((v: any): any => v[searchType]);
        if (savedValue.length > 0) {
          savedValue.forEach((key: any): any => {
            searchList.splice(searchList.indexOf(key), 1);
            var delIndex = -1;
            mallProducts.forEach((item: any, index: number): any => {
              if (item.mallProductNo.toString() == key.toString()) {
                delIndex = index;
              }
            });
            mallProducts.splice(delIndex, 1);
          });
        }
        const failList = keywordList.filter((v: any): any => !searchList.includes(Number(v)));
        const failText = failList.slice(0, 1);
        const message = `${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA1')}${keywordList.length}${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA2')}${failList.length}${this.toI18n(
          'PRODUCT_PRIORITY_MSG_ERROR_DATA3'
        )}${failText}${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA4')}${failList.length - 1}${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA5')}`;

        if (!confirm(message)) {
          return;
        }
      }
      let mallProductsSort = [...mallProducts];
      if (searchTypeParam !== 'PRODUCT_MANAGEMENT_CD_LIKE') {
        mallProductsSort = [];
        keywordList.forEach((keyword: string): void => {
          const mallProduct = mallProducts.find((mallProduct: any): boolean => {
            if (searchTypeParam === 'PRODUCT_MANAGEMENT_CD') {
              return mallProduct.productManagementCd.toString().includes(keyword.toString());
            }
            return mallProduct.mallProductNo.toString() === keyword.toString();
          });
          if (mallProduct) {
            mallProductsSort.push(mallProduct);
          }
        });
      }

      this.add(mallProductsSort).then((): void => {
        this.addProductSuccessHandle(mallProductsSort);
        if (callBack) {
          callBack(mallProductsSort);
        }
      });
    });
  }

  public addProduct(): void {
    const searchType = this.searchType;
    if (!this.keyword) {
      this.invalid(this.toI18n('PRODUCT_PRIORITY_PLEASE_ENTER_YOUR_PRODUCT_NUMBER'));
      return;
    } else if (searchType === 'mallProductNo' && !this.keywordCheck()) {
      return;
    }

    this.isInvalidOfKeyword = false;
    const keywordList = this.keyword
      .replace(/(\n|\r\n)/g, ',')
      .split(',')
      .filter((v: any): boolean => !!v)
      .map((v: any): string => (searchType === 'mallProductNo' ? parseInt(v, 10) : v));
    const keyword = keywordList.join(',');

    this.addProductBySearch(searchType, keyword, keywordList);
  }

  public openPop(type: string): void {
    const isRemove = type === 'remove';
    const typeText = isRemove ? this.toI18n('PRODUCT_PRIORITY_DELETE') : this.toI18n('PRODUCT_PRIORITY_ADD');
    const popupName = {add: this.toI18n('PRODUCT_PRIORITY_PRODUCT_INQUIRY_REGISTRATION_POP'), remove: this.toI18n('PRODUCT_PRIORITY_SANG_FORM_INQUIRY_DELETE_POPUP')};
    const params = [
      `callBackName=ncp.priority.searchPopupCallback.${type}`,
      `callbackParam=${type}`,
      `mallNo=${this.currentMallNo}`,
      'allBtn=true',
      'customProperty=true',
      'emptyAlert=' + this.toI18n('PRODUCT_PRIORITY_EMPTYALERT'),
      `addConfirm=${this.toI18n('PRODUCT_PRIORITY_ADDCONFIRM1')}${isRemove ? `${this.toI18n('PRODUCT_PRIORITY_ADDCONFIRM2')}` : ''} ${typeText}${this.toI18n(
        'PRODUCT_PRIORITY_ADDCONFIRM3'
      )}${typeText}${this.toI18n('PRODUCT_PRIORITY_ADDCONFIRM4')}`,
      `addAllConfirm=${this.toI18n('PRODUCT_PRIORITY_ADDALLCONFIRM1')}${isRemove ? `${this.toI18n('PRODUCT_PRIORITY_ADDALLCONFIRM2')}` : ''} ${
        !isRemove ? `${this.toI18n('PRODUCT_PRIORITY_ADDALLCONFIRM3')}` : ''
      }${typeText}${this.toI18n('PRODUCT_PRIORITY_ADDALLCONFIRM4')}${typeText}${this.toI18n('PRODUCT_PRIORITY_ADDALLCONFIRM5')}`
    ];

    const grid = this.getTuiGrid();
    if (type === 'remove') {
      if (grid.invoke('getRowCount') === 0) {
        alert(this.toI18n('PRODUCT_PRIORITY_NO_REG_PRODUCT_ALERT'));

        return;
      }
      params.push('addSelectedBtn=' + this.toI18n('PRODUCT_PRIORITY_ADDSELECTEDBTN'));
      params.push('addAllBtn=' + this.toI18n('PRODUCT_PRIORITY_ADDALLBTN'));
      params.push('target=ncp.priority.getExceptedMallProductNos');
      localStorage.removeItem('productPrioriytExceptedNos');
    } else {
      // params.push('exceptedTarget=ncp.priority.getExceptedMallProductNos');
      // localStorage.setItem('productPrioriytExceptedNos', localStorage.productPriorityProductNos);
    }

    const url = `/product/search/popup?${params.join('&')}`;
    window.open(url, popupName[type], centerWinOptions(1250, 1024));
  }

  public save(): void {
    this.isModified = false;
    const data = {
      mallNo: this.currentMallNo,
      productNos: this.getGridProductNos()
    };
    this.$api
      .postDisplayPriorities({data})
      .then((res: any): void => {
        if (res.status === 204) {
          alert(this.toI18n('PRODUCT_PRIORITY_HAS_BEEN_SAVED'));
        }
      })
      .finally((): void => {
        this.search();
      });
  }

  public created(): void {
    const noData = this.$t('PRODUCT_PRIORITY_NO_REG_PRODUCT_ALERT') as string;
    TuiGrid.setLanguage(Cookies.get('locale'), {
      display: {
        noData
      }
    });
  }

  private beforeDestroy(): void {
    const noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage(Cookies.get('locale'), {
      display: {
        noData
      }
    });
  }

  public mounted(): void {
    this.girdItemPositionSwitch();
    this.removeProductRowEvent();
    remove = this.remove;
    addProductsFromPop = this.addProductsFromPop;
  }

  public remove(mallProductNos: any): void {
    this.gridResetData((item: any): boolean => !mallProductNos.includes(item.productNo));
  }

  public mapProductsData(mallProducts: any): any {
    return mallProducts.map((item: any): any => {
      const productNo = item.productNo ? item.productNo : item.mallProductNo;
      const {
        productManagementCd,
        productName,
        brandName,
        partnerName,
        applyStatusType,
        saleStatusType,
        saleSettingStatusType,
        frontDisplayable: displayable,
        supplyPrice: priceAppliedImmediateDiscount,
        productStock: {representCnt: stock},
        onlyAccessUrl,
      } = item;
      return {
        productNo,
        productManagementCd,
        productName,
        brandName,
        partnerName,
        applyStatusType,
        saleStatusType,
        saleSettingStatusType,
        displayable,
        priceAppliedImmediateDiscount,
        stock,
        onlyAccessUrl,
      };
    });
  }

  public addProductsFromPop(mallProducts: any): void {
    const grid = this.getTuiGrid();
    const data = grid.invoke('getData').map((item: any): void => this.handleArrayData(item));
    const accessProducts = mallProducts.filter(product => {
      const finded = data.find(item => (product.productNo == undefined ? product.mallProductNo : product.productNo) === item.productNo);
      return !finded;
    });
    const faildProducts = mallProducts.filter(product => {
      const finded = data.find(item => (product.productNo == undefined ? product.mallProductNo : product.productNo) === item.productNo);
      return finded;
    });
    const newLength = mallProducts.length;
    const faildLength = faildProducts.length;
    if (faildLength && faildLength !== newLength) {
      const message = `${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA1')}${newLength}${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA2')}${faildLength}${this.toI18n(
        'PRODUCT_PRIORITY_MSG_ERROR_DATA3'
      )}${faildProducts[0].productNo == undefined ? faildProducts[0].mallProductNo : faildProducts[0].productNo}${this.toI18n('PRODUCT_PRIORITY_MSG_ERROR_DATA4')}${faildLength - 1}${this.toI18n(
        'PRODUCT_PRIORITY_MSG_ERROR_DATA5'
      )}`;
      setTimeout(() => {
        if (confirm(message)) {
          this.add(accessProducts).then((): void => {
            this.addProductSuccessHandle(accessProducts);
          });
        }
      });
    } else if (faildLength === newLength) {
      setTimeout(() => {
        alert(this.toI18n('PRODUCT_PRIORITY_THERE_ARE_NO_PRODUCTS_AVAILABLE_FOR_REGISTRATION'));
      });
    } else if (!faildLength) {
      setTimeout(() => {
        alert(`${accessProducts.length}${this.toI18n('PRODUCT_PRIORITY_PRODUCTS_HAVE_BEEN_REGISTERED')}`);
      });
      this.add(accessProducts).then((): void => {
        this.addProductSuccessHandle(accessProducts);
      });
    }
  }

  public add(mallProducts: any): any {
    const newProducts = this.mapProductsData(mallProducts);
    const grid = this.getTuiGrid();
    const data = grid.invoke('getData').map((item: any): void => this.handleArrayData(item));
    grid.invoke('resetData', newProducts.concat(data));
    return new Promise((resolve: any): void => {
      setTimeout((): void => {
        this.gridResetData();
        setTimeout((): void => {
          resolve();
        });
      });
    });
  }

  public get judgeMallLength(): any {
    if (this.malls && this.malls.length && this.malls.length > 1) {
      return 'notice_box';
    } else {
      return 'notice_box mt-0';
    }
  }
}
